import CreateGoogleSheetsAudience from '@extension/context/content/components/bt-bulk-dashboard/audiences/create-google-sheets-audience'
import React from 'react'
import { cn } from '@/lib/utils';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { BsCheckCircleFill } from 'react-icons/bs'
import { MdClose } from 'react-icons/md'
import Dropzone from './dropzone'
import { importItemsActions } from '@common-reducers/ImportItemsReducer'
import { getRuntimeUrl } from '@common-services/storage'
import FileSaver from 'file-saver'
import { getBoardSampleCSVThunk } from '@common-reducers/BoardsThunks'
import { supportedColumnTypes } from './import-excel'
import { useTranslation } from 'react-i18next'
import { namespace } from '@common/config/constants'


type Props = {
    goNext: (isFromSheets?: boolean) => void;
}

export default function FecthDataToImportDialog({ goNext }: Props) {
    const { t } = useTranslation(namespace);

    const dispatch = useAppDispatch()

    const importType = useAppSelector((state) => state.ModalReducer.importType)
    const importFileName = useAppSelector((state) => state.ImportItemsReducer.importFileName);
    const openedby = useAppSelector((state) => state.ModalReducer.openedby)


    const downloadFile = async () => {
        if (openedby === 'campaign') {
            const src = getRuntimeUrl('img/sample.csv');
            FileSaver.saveAs(src, 'sample.csv');
        } else {
            const donwloadSampleFile = await dispatch(getBoardSampleCSVThunk({ supportedColumnTypes }))
        }
    };


    return (
        <>
            <div className="w-auto">
                <h3 className="flex items-center font-bold text-2xl text-[var(--color-text)] dark:text-[var(--color-text)] mb-0">
                    {openedby === 'campaign' ? t('importExcelToBlueticks.importContactsFromSpreadsheet') : t('importExcelToBlueticks.importItemsFromSpreadsheet')}
                </h3>
                <p className="text-sm text-[var(--color-text)] dark:text-[var(--color-text)] my-2.5 px-0">
                    {openedby === 'campaign' ? t('importExcelToBlueticks.transferRecordsAudience') : t('importExcelToBlueticks.transferRecords')}
                </p>
            </div>
            {importType === 'csv' && importFileName && (
                <div className="my-[10px] lg:my-[123px] flex flex-wrap items-center justify-center">
                    <div className="mb-[15px] flex justify-center flex-[100%]">
                        <BsCheckCircleFill color='#00c875' size={35} />
                    </div>
                    <p className="m-5 text-[var(--color-text)] dark:text-[var(--color-text)]"> 
                        {t('importExcelToBlueticks.yourFileHasBeenUploadedSuccessfully')}
                    </p>
                    <div className={cn(
                        "w-fit flex flex-wrap items-center justify-center justify-self-center",
                        "px-2.5 py-1.25 rounded-[6px] text-[13px]",
                        "text-[var(--color-surface)] dark:text-[var(--color-surface)]",
                        "bg-[var(--color-accent)] dark:bg-[var(--color-accent)]"
                    )}>
                        <span className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap inline-block flex-[65%] px-0 my-0">
                            {importFileName}
                        </span>
                        <button 
                            onClick={() => dispatch(importItemsActions.resetImport())}
                            className="ml-1 px-0.5 py-0 flex items-center justify-center cursor-pointer border-0 bg-transparent text-[var(--color-surface)] dark:text-[var(--color-surface)]"
                        >
                            <MdClose size={18} />
                        </button>
                    </div>
                </div>
            )}
            {importType === 'csv' && !importFileName && (
                <div className="mt-2.5 lg:mt-[10px]">
                    <Dropzone />
                </div>
            )}

            {importType === 'google' && (
                <CreateGoogleSheetsAudience goNext={goNext} />
            )}

            <div className="mt-2.5 lg:mt-[10px] text-center">
                <h4 className="text-[15px] font-semibold px-0 my-0 text-[var(--color-text)] dark:text-[var(--color-text)]">
                    {t('importExcelToBlueticks.wonderingHowToGetStarted')}
                </h4>
                <p className="text-[13px] my-2.5 px-0 text-[var(--color-text)] dark:text-[var(--color-text)]">
                    <span 
                        className="text-[#1f76c2] dark:text-[#1f76c2] cursor-pointer hover:underline"
                        onClick={downloadFile}
                    >
                        {t('importExcelToBlueticks.download')}
                    </span>
                    {' '}
                    {t('importExcelToBlueticks.sampleExcelFile')}
                </p>
            </div>
        </>
    )
}